import styled from 'styled-components';
import type { ExtendedTheme } from '@theme/theme';

const StyledError = styled.div`
  color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.primary};

  .error-page {
    &__title {
      padding: 10px 0;
      font-size: 30px;
      line-height: 35px;
      text-align: center;
      letter-spacing: -0.5px;
    }

    &__text {
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.2px;
      margin-bottom: 40px;
      color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.secondary};
    }

    &__error-name {
      font-size: 12px;
      line-height: 15px;
      font-weight: 900;
      text-align: center;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }

    &__block {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 170px 0 150px;
      ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('sm')} {
        margin: 150px 0;
      }
      &--error-403 {
        margin: 120px 0 140px;
        align-items: flex-start;
        ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('sm')} {
          margin: 60px 0;
        }
      }
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 30px;
      box-sizing: border-box;
      max-width: 480px;
      ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('sm')} {
        margin: 0 35px;
      }
      &--error-403 {
        justify-content: flex-start;
        align-items: stretch;
        width: 100%;
        max-width: 800px;
        margin: 0 20px;
        ${({ theme }: { theme: ExtendedTheme }) => theme.breakpoints.down('sm')} {
          margin: 0 20px;
        }
        & .error-page__title {
          padding: 10px 0 20px;
          text-align: left;
        }
        & .error-page__text {
          text-align: left;
          padding-bottom: 48px;
          margin-bottom: 48px;
          border-bottom: 1px solid ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.secondary};
        }
      }
    }

    &__logo {
      width: 52px;
      height: 60px;
      margin-bottom: 30px;
      background-image: url("data:image/svg+xml,%3Csvg width='52' height='60' viewBox='0 0 52 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='0.3' fill-rule='evenodd' clip-rule='evenodd' d='M0 4.70214C0 1.26721 1.25785 0 4.66565 0H47.3309C50.7387 0 51.9966 1.26721 51.9966 4.70214V46.1507C51.9966 46.54 51.9966 49.2291 49.3204 50.6497C46.6441 52.0702 28.38 59.3883 28.38 59.3883C27.3051 59.885 26.7854 60.0142 25.9983 59.9988C25.1147 59.9988 24.7834 59.882 23.6057 59.3883C23.6057 59.3883 5.35421 51.833 2.6771 50.6497C0.223243 49.515 0.125579 46.9359 0.0662856 46.1507C0.0322166 45.8156 0.0662856 30.3893 0.0662856 30L0 4.70214Z' fill='%23141414' fill-opacity='0.32'/%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='52' height='60'%3E%3Cpath opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M0 4.70214C0 1.26721 1.25785 0 4.66565 0H47.3309C50.7387 0 51.9966 1.26721 51.9966 4.70214V46.1507C51.9966 46.54 51.9966 49.2291 49.3204 50.6497C46.6441 52.0702 28.38 59.3883 28.38 59.3883C27.3051 59.885 26.7854 60.0142 25.9983 59.9988C25.1147 59.9988 24.7834 59.882 23.6057 59.3883C23.6057 59.3883 5.35421 51.833 2.6771 50.6497C0.223243 49.515 0.125579 46.9359 0.0662856 46.1507C0.0322166 45.8156 0.0662856 30.3893 0.0662856 30L0 4.70214Z' fill='white' fill-opacity='0.72'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Crect opacity='0.4' y='47.5977' width='70.0994' height='14' transform='rotate(-45 0 47.5977)' fill='%23141414' fill-opacity='0.32'/%3E%3C/g%3E%3C/svg%3E%0A");
      background-position: center center;
      background-repeat: no-repeat;
      filter: ${({ theme }: { theme: ExtendedTheme }) => (theme.palette.mode === 'dark' ? 'invert(1)' : 'none')};
    }
  }
`;

const Styled403ListBox = styled.div`
  & .page-403 {
    &__h4 {
      color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.text.primary};
      padding-bottom: 16px;
    }
    &__box {
      max-width: 420px;
      margin: 20px 0 24px;
    }
    &__list-text {
      padding: 0 0 24px !important;
      & > span {
        line-height: 24px;
      }
    }
    &__icon {
      display: flex;
      min-width: 20px;
      min-height: 20px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      justify-content: center;
      align-items: center;
      background-color: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.components.tagBorder};
      font-size: 12px;
      border-radius: 50%;
      margin-right: 18px;
    }

    &__list {
      margin-top: 20px !important;
      .MuiListItem-root {
        padding: 0;
      }
    }
  }
`;

export { StyledError, Styled403ListBox };
